// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"TermEditCompanyAccounts_formContainer__1Nn2r"};